var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-tech-requirements"},[(_vm.isLoading)?_c('base-preloader-gif',{attrs:{"size":40}}):_vm._e(),_c('div',{staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.techReq)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }